export const blockIconsTravelGolfCourseNew = (
	<span className='material-symbols-outlined'>golf_course</span>
);
